import Vue from 'vue';
import TombolaBaseComponent from '@/components/base/base.component';
import { Component, Prop } from 'vue-property-decorator';
import { GameState, IGameRepresentationChangedArgs, IGameStateChangedArgs } from '@/components/game/_domain/models';
import { IHamsterRaceGameRepresentation } from '@/components/game/implementations/uk/hamster-race/_domain/controller/game-controller';
import { IGameController } from '@/components/game/_domain/models/game-controller';

@Component({
  name: 'HamsterRaceCallValueComponent'
})
export default class HamsterRaceCallValueComponent extends TombolaBaseComponent {
  @Prop() public gameController: IGameController;
  private gameHamsterSet: number = 0;
  private firstPlaceHamsterNumber: number = 0;
  private gameState: GameState = GameState.InPlay;

  private mounted() {
    this.gameController
          .onGameRepresentationChanged(this.handleGameRepresentationChanged)
          .onGameStateChanged(this.handleGameStateChanged);
  }

  private get firstPlaceHamsterImageUrl(): string {
    const hamsterRaceCallImagesFolder = '/static/games/hamsterrace/skins';
    if (this.firstPlaceHamsterNumber > 0 && this.gameHamsterSet > 0) {
      return `${hamsterRaceCallImagesFolder}/set-${this.gameHamsterSet}/${this.firstPlaceHamsterNumber}-with-name.png`;
    }
    return `${hamsterRaceCallImagesFolder}/placeholder.png`;
  }

  private handleGameRepresentationChanged(eventArgs: IGameRepresentationChangedArgs) {
    const gameRepresentation: IHamsterRaceGameRepresentation = eventArgs.currentGameRepresentation;
    const hamsterInFirstPlace = gameRepresentation.hamsterInFirstPlace;
    this.gameHamsterSet = gameRepresentation.hamsterSet;
    this.firstPlaceHamsterNumber = hamsterInFirstPlace ? hamsterInFirstPlace.hamsterNumber : 0;
  }

  private handleGameStateChanged(eventArgs: IGameStateChangedArgs) {
    this.gameState = eventArgs.currentGameState;
  }

  private isGameInPlay() {
    return this.gameState === GameState.InPlay;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/uk/hamster-race/_components/call-value/call-value.component.ts